export default __webpack_public_path__ + "static/media/fire.b82ab726.svg";